/**
 * Outgoing Transfers Fragment
 * Handles list date filter interactions
 */

import { Events } from '../../../../js/utils/events.js';

let initialized = false;

// ============================================================================
// Transfer List Filter Handlers
// ============================================================================

const TransferListFilter = {
    /**
     * Toggle all outgoing transfer checkboxes
     */
    onToggleAllOutgoing(e, element) {
        const checked = element.checked;
        const checkboxes = document.querySelectorAll('.outgoing-checkbox');
        checkboxes.forEach(cb => {
            cb.checked = checked;
        });
    },

    /**
     * Handle bulk delete of selected outgoing transfers
     */
    onBulkDelete(e, element) {
        const checkboxes = document.querySelectorAll('.outgoing-checkbox:checked');
        if (checkboxes.length === 0) {
            alert('Please select transfers to delete');
            return;
        }

        if (!confirm('Delete ' + checkboxes.length + ' selected transfer(s)?')) {
            return;
        }

        // Store original button state and show deleting state
        const deleteButton = element;
        const originalText = deleteButton.textContent;
        deleteButton.textContent = 'Deleting...';
        deleteButton.disabled = true;
        deleteButton.classList.add('opacity-50', 'cursor-not-allowed');

        // Create temporary form with selected transfer OIDs
        const tempForm = document.createElement('form');
        tempForm.style.display = 'none';
        checkboxes.forEach(cb => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'transfer_oids';
            input.value = cb.value;
            tempForm.appendChild(input);
        });
        document.body.appendChild(tempForm);

        // The refresh re-runs the list handler, which reads its state from the query
        // string. Without this the table comes back in the default view, which after
        // deleting from the by-transfer view means every row changes meaning.
        const filters = document.getElementById('outgoing-transfers-filters');
        const params = new URLSearchParams(filters ? new FormData(filters) : undefined);
        // Back to the first page: the deleted rows were on this one, and a preserved
        // offset can land past the end of a list that just got shorter.
        params.set('start', '0');

        // Use HTMX to submit and refresh the list
        htmx.ajax('POST', '/app/transfers/outgoing/delete?' + params.toString(), {
            source: tempForm,
            target: '#outgoing-transfers',
            swap: 'outerHTML'
        }).then(() => {
            document.body.removeChild(tempForm);
        }).catch(() => {
            // Reset button state on error
            deleteButton.textContent = originalText;
            deleteButton.disabled = false;
            deleteButton.classList.remove('opacity-50', 'cursor-not-allowed');
        });
    },

    /**
     * Handle pagination - go to specific page offset
     */
    onGotoPage(e, element) {
        const offset = element.dataset.offset;
        const container = element.closest('#outgoing-transfers');
        if (!container) return;

        const form = container.querySelector('form');
        const startInput = container.querySelector('#pagination-start');
        if (form && startInput) {
            startInput.value = offset;
            form.requestSubmit();
        }
    }
};

// ============================================================================
// Initialization
// ============================================================================

export function initTransferOutgoing() {
    if (initialized) return;
    initialized = true;

    // Select all outgoing transfers checkbox
    Events.on('change', 'transfer-outgoing-select-all', (e, element) => {
        TransferListFilter.onToggleAllOutgoing(e, element);
    });

    // Bulk delete button
    Events.on('click', 'transfer-outgoing-bulk-delete', (e, element) => {
        TransferListFilter.onBulkDelete(e, element);
    });

    // Pagination buttons
    Events.on('click', 'transfer-outgoing-goto-page', (e, element) => {
        TransferListFilter.onGotoPage(e, element);
    });

    console.log('[LeapFILE] Transfer outgoing fragment initialized');
}
